export const testId = (id: string) => ({ 'data-testid': id }); 